import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertySmoovedTypesStore from "./property-smooved-types.store";

const smoovedActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{
  [propertySmoovedTypesStore.Get.PUBLISH_SMOOVED]: ({ getters, commit }, param: number) => {
    return getters.service['getPublishSmooved'](param)
      .then((data) => {
        commit(propertySmoovedTypesStore.Set.SMOOVED_REQUEST_INFO, data);
        commit(propertySmoovedTypesStore.Set.SMOOVED_ASSIGN_VALUE, { PropertyId: param });
        if (data.ContactInfos[0]) {
          commit(propertySmoovedTypesStore.Set.PRIMARY_CONTACT_ASSIGNVALUE, { ...data.ContactInfos[0] });
        } else {
          commit(propertySmoovedTypesStore.Set.PRIMARY_CONTACT_RESET);
        }
        commit(propertySmoovedTypesStore.Set.SECONDART_CONTACT_RESET);
        commit(propertySmoovedTypesStore.Set.LEAVING_CUSTOMER_RESET);
        commit(propertySmoovedTypesStore.Set.CONNECTION_RESET);
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  },
  publishSmooved: ({ getters, commit }) => {
    if (getters.SecondaryContact && !getters.SecondaryContact.Id) {
      commit(propertySmoovedTypesStore.Set.SMOOVED_ASSIGN_VALUE, { SecondaryContact: null });
    }
    if (getters.LeavingCustomer && !getters.LeavingCustomer.Id) {
      commit(propertySmoovedTypesStore.Set.SMOOVED_ASSIGN_VALUE, { LeavingCustomer: null });
    }
    return getters.service['publishSmooved'](getters.smooved)
      .then((data) => { 
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  }
}

export default smoovedActions;